import { render, staticRenderFns } from "./LandingSplash.vue?vue&type=template&id=560fe578&scoped=true&"
import script from "./LandingSplash.vue?vue&type=script&lang=js&"
export * from "./LandingSplash.vue?vue&type=script&lang=js&"
import style0 from "./LandingSplash.vue?vue&type=style&index=0&id=560fe578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560fe578",
  null
  
)

export default component.exports